import React from 'react';
import { Autocomplete, TextField, Checkbox, Box } from '@mui/material';
import styles from '../Common/Inventory.module.css';
import { checkBoxSx, getOptionStylesAndHandlersForMultiSelectAutocomplete } from '../Common/inventory.helper';



interface OptionType {
  label: string;
  id: number;
}

interface MultiSelectAutocompleteWithChipsProps {
  'data-testid'?: string;
  options: OptionType[];
  value: OptionType[];
  onChange: (value: OptionType[]) => void;
  label: React.ReactNode;
  name: string;
  renderChip: (item: OptionType, onDelete: (id: number) => void) => React.ReactNode;
  sx?: object;
  subLabelSx?: object;
  noOptionsText?: string;
  error?: boolean;
}

const MultiSelectAutocompleteWithChips: React.FC<MultiSelectAutocompleteWithChipsProps> = ({
  'data-testid': dataTestId,
  options,
  value,
  onChange,
  label,
  name,
  renderChip,
  subLabelSx = {},
  noOptionsText,
  error = false,
}) => {
  return (
    <>
      <Autocomplete
        data-testid={dataTestId}
        multiple
        disableCloseOnSelect
        options={options}
        getOptionLabel={(option) => option.label}
        value={value || []}
        onChange={(_, newValue) => onChange(newValue)}
        noOptionsText={noOptionsText}
        renderOption={(props, option, { selected }) => {
          const { style, ...eventHandlers } = getOptionStylesAndHandlersForMultiSelectAutocomplete(selected);
          return (
            <li
              {...props}
              style={style}
              {...eventHandlers}
            >
              <Checkbox
                checked={selected}
                sx={{ ...checkBoxSx, p: 0.5, mr: 1 }}
                icon={<span className={styles.AutoCompleteDropDownIcon} />}
                checkedIcon={<span className={styles.AutoCompleteDropDowncheckedIcon}>✔</span>}
              />
              {option.label}
            </li>
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            name={name}
            label={label}
            error={error}
            sx={subLabelSx}
            size="small"
            variant="outlined"
          />
        )}
        renderTags={() => null}
        isOptionEqualToValue={(option, v) => option && v && option.id === v.id}
        fullWidth
        disableListWrap
        slotProps={{
          paper: {
            sx: { maxHeight: 250, overflowY: 'auto' },
          },
          listbox: {
            sx: { maxHeight: 'none', overflow: 'visible' },
          },
        }}
      />
      {/* Show selected chips below Autocomplete */}
      <Box mt={1} display="flex" flexWrap="wrap" gap={1}>
        {(value || []).map((item) => renderChip(item, (id) => {
          const newSelectedItems = (value || []).filter((selectedItem) => selectedItem.id !== id);
          onChange(newSelectedItems);
        }))}
      </Box>
    </>
  );
};

export default MultiSelectAutocompleteWithChips;
